import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Logo } from "../assets/logo/Logo";
import HeaderStyle from "../assets/stylesheets/Header.module.css";

export default function KoreaHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  // SNS 아이콘 주소
  const icons = {
    tiktok: "https://cdn-icons-png.flaticon.com/512/3046/3046124.png",
    instagram: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
  };

  const menuItems = [
    { id: "home", title: "홈페이지", path: "/global" },
    {
      id: "experience",
      title: "농장체험",
      path: "/experience"
    },
    { id: "farmstay", title: "팜스테이", path: "/stay" },
    { id: "market", title: "팜마켓", path: "/store" }
  ];

  return (
    <header style={styles.headerContainer}>
      <div style={styles.headerInner}>
        {/* 1. LEFT: BRAND LOGO AREA */}
        <div className={HeaderStyle["logo-container"]}>
          <a
            href="/global"
            className={HeaderStyle["logo-link"]}
            style={styles.logoFlexAnchor}
          >
            <Logo className={HeaderStyle["logo"]} aria-label="Farmciti Logo" />
            <span style={styles.logoSubBadge}>KOREA</span>
          </a>
        </div>

        {/* 2. CENTER: NAVIGATION (높이 종속을 깨고 글자 바로 아래 밑줄 정렬) */}
        <nav style={styles.navMenuWrapper}>
          {menuItems.map((item) => {
            const isActive = currentPath === item.path;

            return (
              <div
                key={item.id}
                style={{
                  ...styles.navItemCard,
                  // 🌟 이제 전체 높이 보더가 아닌, 글자 단락 하단 보더로 작동합니다.
                  borderBottom: isActive
                    ? "2px solid #1a4331"
                    : "2px solid transparent",
                  color: isActive ? "#1a4331" : "#718096"
                }}
                onClick={() => navigate(item.path)}
              >
                <span style={styles.menuTitleText}>{item.title}</span>
              </div>
            );
          })}
        </nav>

        {/* 3. RIGHT: SOCIAL MEDIA LINKS AREA */}
        <div style={styles.socialLinkGroup}>
          <a
            href="https://www.instagram.com/farmciti.ca/"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.socialIconAnchor}
            title="Instagram"
          >
            <img
              src={icons.instagram}
              alt="Instagram"
              style={styles.socialSvgIcon}
            />
          </a>
          <a
            href="https://www.tiktok.com/@farmciti_canada"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.socialIconAnchor}
            title="TikTok"
          >
            <img src={icons.tiktok} alt="TikTok" style={styles.socialSvgIcon} />
          </a>
        </div>
      </div>
    </header>
  );
}

/* ==========================================
   DESIGN SYSTEM STYLES (비율 교정 완료)
========================================== */
const styles = {
  headerContainer: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #f1f3f5",
    position: "sticky",
    top: 0,
    zIndex: 9999,
    boxShadow: "0 1px 12px rgba(0,0,0,0.02)",
    padding: "0 40px",
    // 🌟 헤더 두께를 기존 80px에서 컴팩트하고 시원한 64px로 최적화 슬림화 진행
    height: "64px",
    display: "flex",
    alignItems: "center"
  },
  headerInner: {
    width: "100%",
    maxWidth: "1280px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  logoFlexAnchor: {
    display: "inline-flex",
    alignItems: "center",
    textDecoration: "none",
    verticalAlign: "middle"
  },
  logoSubBadge: {
    fontSize: "9px",
    fontWeight: "800",
    backgroundColor: "#f0fdf4",
    color: "#166534",
    padding: "2px 6px",
    borderRadius: "4px",
    border: "1px solid #bbf7d0",
    letterSpacing: "0.5px",
    display: "inline-block",
    whiteSpace: "nowrap"
  },
  navMenuWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px", // 카드 간격을 좁히고 패딩 위주로 제어
    height: "100%"
  },
  navItemCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // 🌟 [핵심 변경] height를 100%로 잡되, 내부 상하 패딩(padding)을 주어
    // 밑줄이 글자 바로 밑에(너무 가깝지도 멀지도 않게) 안착하도록 비율 유도
    height: "auto",
    padding: "6px 16px",
    cursor: "pointer",
    transition: "all 0.15s ease",
    boxSizing: "border-box"
  },
  menuTitleText: {
    fontSize: "14px", // 에어비앤비 특유의 미니멀 14px 매칭
    fontWeight: "600",
    letterSpacing: "-0.2px",
    lineHeight: "1.2"
  },
  socialLinkGroup: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  socialIconAnchor: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#f8f9fa",
    transition: "background-color 0.2s ease"
  },
  socialSvgIcon: {
    width: "16px",
    height: "16px",
    objectFit: "contain",
    opacity: 0.75
  }
};
